import axios from "axios";
import { getApiBase } from "@/apiBase";

const API_BASE = getApiBase();

export const api = axios.create({ baseURL: API_BASE || undefined });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
